export default {
    'diagram3b1-3': {
        'checkboxes': {
            'title': 'Question:	',
            'checkbox-1': 'Why did they?',
            'checkbox-2': 'How did they?',
            'checkbox-3': 'How do you know they did?',
        },
        'elements': {
            'one': 'The government, the accountants, and the markets together killed pensions',
            'two': 'Government stopped companies from weaseling out of pension promises ',
            'three': 'Accountants required companies to record the cost of such pension promises',
            'four': 'Market downturn encouraged companies to end pensions if they could'
        },
        'checkboxes-bottom': {
            'title': 'General Plural Noun',
            'checkbox-1': 'Reasons',
            'checkbox-2': 'Steps',
            'checkbox-3': 'Proofs',
        },
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b1/diagram3/i18n/en.js